import React, { PureComponent } from 'react';
import './calendar.css';

const DATE_STR = ['日','月','火','水','木','金','土']

export default class Calendar extends PureComponent {
  constructor(props) {
    super();
    this.state = {
      date: props.date,
    }
    this.prev = this.prev.bind(this);
    this.now = this.now.bind(this);
    this.next = this.next.bind(this);
  }
  prev() {
    const y = this.state.date.getFullYear() - ((this.state.date.getMonth() === 0) ? 1 : 0);
    const m = (this.state.date.getMonth() > 0) ? this.state.date.getMonth()-1 : 11;
    this.setState({
      date: new Date(y, m, 1)
    });
  }
  now() {
    this.setState({
      date: new Date()
    });
  }
  next() {
    const y = this.state.date.getFullYear() + ((this.state.date.getMonth() === 11) ? 1 : 0);
    const m = (this.state.date.getMonth() < 11) ? this.state.date.getMonth()+1 : 0;
    this.setState({
      date: new Date(y, m, 1)
    });
  }


  render() {
    const date = this.state.date;
    const year = date.getFullYear();
    const month = date.getMonth()+1;
    const day1 = new Date(`${year}-${month}-1`)
    const begin = new Date(day1.getTime() - day1.getDay()*86400000);
    let d = begin;
    const list = [];
    do {
      const cols = []
      for (let i=0; i<7; i++) {
        cols.push(d);
        d = new Date(d.getTime()+86400000)
      }
      list.push(cols);
    } while (d.getMonth()+1 === month)
    return (
      <>
        <div className="flex">
          <div onClick={this.prev}>　≪　</div>
          <div onClick={this.now}>{`${year}/${month}`}</div>
          <div onClick={this.next}>　≫　</div>
        </div>
        <table border='1' cellspacing='0'>
          <thead>
            <tr>
              {
                DATE_STR.map((s)=>(<th>{s}</th>))
              }
            </tr>
          </thead>
          <tbody>
            {
              list.map((cols)=>(<tr>{
                cols.map((c)=>(<td>{
                  this.props.renderItem?.(c) ?? `${c.getMonth()+1}/${c.getDate()}`
                }</td>))
              }</tr>))
            }
          </tbody>
        </table>
      </>
    );
  }
}
